import type { CreateUserInput, PublicUser, UpdateUserInput } from '@wave/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from './client';

const KEY = ['admin', 'users'] as const;

export function useUsers() {
  return useQuery({
    queryKey: KEY,
    queryFn: () => api.get<PublicUser[]>('/admin/users'),
  });
}

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: CreateUserInput) => api.post<PublicUser>('/admin/users', input),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useUpdateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (vars: { id: string; patch: UpdateUserInput }) =>
      api.patch<PublicUser>(`/admin/users/${vars.id}`, vars.patch),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}

export function useDeleteUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete<{ ok: true }>(`/admin/users/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: KEY }),
  });
}
